import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useGetSinglePodcastTicket(data = {}) {
  const { enabled = false, configs = {}, ticketId } = data;
  const { params = {} } = configs;
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;

  function getOneTicket() {
    return privateFetch
      .get(`/v1/admin/podcast/support/ticket/${ticketId}`, configs)
      .then((res) => res.data);
  }

  return useQuery(['podcast-ticket-getResource', params], getOneTicket, {
    enabled,
    keepPreviousData: true,
  });
}

export default useGetSinglePodcastTicket;
